import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth53: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M192.5,116.5c-92.4-22.3-174.1,0-174.1,0l-4.3-9.3v-10s3.3-13.2,3.3-13.2c97.9-20.3,176.1,0,176.1,0l4.8,9.7v11.8s-5.8,11.1-5.8,11.1h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M68.8,71.4h79.3c-7.4-69.4-79.3,0-79.3,0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M179.4,64.6c-62.6,33.3,2.7,65.4,2.7,65.4l10.3-13.3,5.8-11.1v-11.8s-4.8-9.7-4.8-9.7l-14-19.6h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.9,133.7l-11.5-17.1-4.3-9.3v-10s3.3-13.2,3.3-13.2l8.5-19.6c73.4,13.1,4,69.2,4,69.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M198.2,97.3c-82-19.6-184.2,0-184.2,0l1.6-6.7,3.8-15.6,6.3-10.5,6.5-10.3,9.2-7.2,15.7-5.6,33-7.2,20.5-3.8,7.4-.9h6.5s8.3,1.3,8.3,1.3l10.3,5.9,12.1,9.7,6.3,4,9.2,5.5,8.7,8.6,18.8,29.3v3.4s0,0,0,0Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M198.2,97.1c-83.2-19.4-184.2,0-184.2,0v9.2s2.2,6.5,2.2,6.5l5.6,9.6,12.3,19.1,9,12.5,10.1,11.4,9.4,9.9,14.4,7.9,14.1,2.7,13-.9,12.6-5.4,16.2-8.7,18.2-11.7,16.9-13.3,13.2-13.5,11.9-16,5.1-11v-8.2s0,0,0,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154.4,155.4c-14.9,10.6-38.9,27.7-54.3,29.6-18.5,2.3-36.1-6.2-46.9-21.1-4.2-4.5-7.9-8.6-11.5-13.6-8.7-12.2-17.1-24.1-24.7-37.1s1.8-35.4,9.5-49.5,20.9-20,38.5-23.4l49.8-9.7c11.8-2.3,22.6,1.6,31.3,9.4,14.9,13.2,28.3,14.7,40.8,35.2s16.2,22.2,8,36.2c-10.3,17.7-23.9,32.4-40.6,44.2Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '103.2 9.9 100.8 9 91.3 9 63.1 25.4 52.7 29.4 36.7 37.4 29.9 44.6 146.6 44.6 103.2 9.9',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M181.9,106.6c-81.9-11.6-18.4-49.4-18.4-49.4l13,10.8,5.4,12.2v26.3s0,.1,0,.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M20.2,56.1c76.1,22.4,2.3,51.8,2.3,51.8l-4.2-8.3-5.4-11.4v-8.8s.8-8.8.8-8.8l2.4-8,4.1-6.7v.2Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M84.8,102A14.9,14.9 0 0 1 114.6,102A14.9,14.9 0 0 1 84.8,102Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.6,112.8l-7.1,14.4c-80.8,43.6-138.6-.8-138.6-.8l-9.7-14.6c83.7,46.9,155.4,1.1,155.4,1.1h0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.5,113.1c-80.8,14.8-58-87.6-58-87.6l24.1,19.2,16.9,12.5,13,10.8,5.4,12.2v26.3s-1.3,6.4-1.3,6.4v.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.1,111.6c68.8,14.9,39.5-86.4,39.5-86.4l-27.9,11.9-6.8,7.2-9.8,11.4-4.1,6.7-2.4,8-.8,17.6,9.6,19.7,2.7,4.1v-.2Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M180.6,113.1c-83.2,45.8-155.4-1.1-155.4-1.1l-12.3-23.7.8-17.6,2.4-8,4.1-6.7,16.6-18.5,26.3-12,28.3-16.4h9.4s2.4,1,2.4,1l19.3,15.4,24.1,19.2,16.9,12.5,13,10.8,5.4,12.2v26.3s-1.3,6.4-1.3,6.4v.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M181.4,108.5c-27.7,30-64.9,46.4-105.2,33.1s-38.1-17.8-52.4-33.2c-2.9-3.1-4.5-8-6.2-11.8-5.6-12.3-5-27.4,2.1-39s11.1-14.3,18.1-19.8,17.1-7.2,25.2-11.9l24.6-14.2c7.3-4.2,14.3-3,20.6,2.3l25.3,21.6c13.7,9.6,27.5,17.9,39.2,29.7s10.1,27.1,8.8,43.2Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '114.9 497.5 107.4 501.2 101.7 501.2 92.7 498.4 75.7 489 48 471.7 40.3 462.5 163 462.5 114.9 497.5',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.5,452.2c-56.4-32.3,2-64.6,2-64.6l10.1,23.8-1.3,24.8-10.8,16h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.9,387.5c59.2,35.4-5.9,64.6-5.9,64.6l-7.4-18.6v-23.3s3.9-9.4,3.9-9.4l9.4-13.2h0Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M79.8,427.2h55.3c-25.2-118.9-55.3,0-55.3,0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.2,371.5c-59-31-122.6,1.6-122.6,1.6l-3.7,14.5c77.4-42.2,134.5,0,134.5,0,0,0-8.2-16.1-8.2-16.1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M176.4,387.7c-43.3,11-47.1,99.3-47.1,99.3l33.7-24.5,11.4-10.3,10.8-16,1.3-24.8-10.1-23.8h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.9,387.6c46.7,9,33.8,101.3,33.8,101.3l-27.8-17.3-7.7-9.2-6.1-10.3-5.5-18.6v-23.3s3.9-9.4,3.9-9.4l9.4-13.2h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M176.3,387.7c-67.1-41.8-134.5,0-134.5,0l-13.3,20.6-1.8,9,1.8,16.3,5.4,18.6,6.2,10.3,7.7,9.2,27.8,17.3,17,9.4,9,2.8h5.8s7.4-3.6,7.4-3.6l48.2-35.1,11.4-10.3,10.8-16,1.3-24.8-10.1-23.8h-.1Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M139.3,476.8l-24.7,19.6c-8.1,6.4-17.1,4.8-26.3-.8l-35.6-21.4c-9.3-5.6-15.4-16.3-19.4-26.2s-4.7-22.4-5.2-34c5.5-22.9,23.2-38.7,46.4-42.6,38-6.4,78.9,14.7,110.4,35.4,1,14.9,3.1,27.9-5.7,39.3-6.4,7-12.8,13.9-21,18.9l-18.9,11.7Z',
			},
		},
	},
};
